import { Component, Input, OnInit } from '@angular/core';
import { PerforationIcp } from 'src/app/interfaces/perforation';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-perforation-icp',
  templateUrl: './handover-detail-perforation-icp.component.html',
  styleUrl: './handover-detail-perforation-icp.component.scss',
  standalone: false,
})
export class HandoverDetailPerforationIcpComponent implements OnInit {
  @Input() handoverId: number | undefined;
  @Input() wellUwi: string | undefined;
  @Input() handoverStatusId: number | undefined;

  perforationsIcp: PerforationIcp[] = [];
  isLoading = false;
  displayedColumns = [
    'segmentStatus',
    'top',
    'base',
    'startDate',
    'rePerforation',
  ];
  hideFooter = true;

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellUwi) {
      this.isLoading = true;
      this.handoverService
        .getPerforationsIcp(
          this.handoverId,
          this.wellUwi!,
          this.handoverStatusId!
        )
        .subscribe((p: PerforationIcp[]) => {
          if (p) {
            this.perforationsIcp = p;
            this.hideFooter = this.perforationsIcp!.length > 0;
          }
          this.isLoading = false;
        });
    }
  }
}
